import { CRUDServiceAPI2 } from './crud-service.class'

/** Сервис для запроса всех ТТН безотносительно заявки. */
export class TTNServiceApiV2 extends CRUDServiceAPI2 {
  subject = 'ttns'
}
